import { get, isEmpty } from 'lodash';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Typography } from '@material-ui/core';

import { Box, Dialog } from 'components';
import { RootState } from 'redux-modules/store/rootState';
import InvestNowDeal from 'views/InvestNow';
import { getInvestorDetails } from 'redux-modules/investor/Actions';
import { getInvestorInvestments } from 'services';

import styles from '../styles';

const PendingInvestment = () => {
  const classes = styles();
  const dispatch = useDispatch();
  const [inProgressInvestment, setInProgressInvestment] = React.useState<any>(
    {},
  );
  const { dealList } = useSelector(({ Deals }: RootState) => Deals);

  const [
    openContinueInvestment,
    setOpenContinueInvestment,
  ] = React.useState<boolean>(false);

  const [investSpv, setInvestSpv] = React.useState<any>(null);
  const [rolloverSpv, setRolloverSpv] = React.useState<any>(null); //eslint-disable-line
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  useEffect(() => {
    setIsLoading(true);
    getInvestorInvestments()
      .then((res: any) => {
        const inv = (res || []).find(
          (item: any) =>
            item.isRollover &&
            !get(item, 'investmentProcess.docuSignDocumentSigned'),
        );
        if (inv) {
          setInProgressInvestment(inv);
        }
        console.log(res); //eslint-disable-line
      })
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <div>
      {!isEmpty(inProgressInvestment) && !isLoading && !isEmpty(dealList) && (
        <Box
          className={classes.notificationBox}
          onClick={() => {
            const deal = (dealList || []).find(
              (item) => item.id === inProgressInvestment.spv,
            );
            console.log(deal,inProgressInvestment) //eslint-disable-line

            setOpenContinueInvestment(true);

            setInvestSpv(deal);
          }}
        >
          {' '}
          <Typography className={classes.notificationTxt}>
            There are pending actions related to your roll-over from YC Demo Day
            SPVs. Please complete by clicking here
          </Typography>
        </Box>
      )}

      <Dialog
        open={openContinueInvestment}
        maxWidth={'lg'}
        title=""
        buttonText="submit"
        className={classes.investPopUp}
        handleClose={() => {
          setOpenContinueInvestment(false);
          setInvestSpv(null);
          dispatch(getInvestorDetails());
        }}
      >
        {openContinueInvestment && (
          <InvestNowDeal
            spv={get(investSpv, 'id') || ''} //|| get(latestDeal, 'deal')
            deal={investSpv} //|| latestDeal
            isRolloverFromPortfolio={true}
            reInvestPartial={false}
            distributionData={{
              id: get(inProgressInvestment, 'id'),
              balance:
                get(inProgressInvestment, 'investmentAmount') -
                  parseFloat(
                    get(inProgressInvestment, 'remainingWireAmount'),
                  ) || 0,
              spv: {
                id: get(inProgressInvestment, 'rolloverSpvId'),
              },
            }}
          />
        )}
      </Dialog>
    </div>
  );
};

export default PendingInvestment;
